<template>
  <v-container grid-list-md pa-0 relative>
    <v-layout row wrap>
      <v-flex xs12 sm12>
        <v-card outlined class="primary--border">
          <v-card-title class="title">
            Transport Report
            <v-spacer></v-spacer>
            <v-menu
              v-if="transportForm.items.data.length > 0"
              class="download_drop"
              :close-on-content-click="false"
              offset-y
            >
              <template v-slot:activator="{ attrs, on }">
                <v-btn
                  :color="'success'"
                  class="white--text"
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  small
                >
                  <v-icon left small>cloud_download</v-icon>
                  &nbsp;DOWNLOAD TRANSPORT REPORT
                </v-btn>
              </template>

              <v-list dense>
                <v-subheader>COLUMNS</v-subheader>

                <v-list-item
                  v-for="(column, key) in downloadColumns"
                  :key="key"
                  link
                >
                  <v-checkbox
                    v-model="column.selected"
                    :label="column.name"
                    color="success"
                    hide-details
                  ></v-checkbox>
                </v-list-item>
                <v-subheader>ACTIONS</v-subheader>
                <v-list-item-group color="primary">
                  <v-list-item
                    v-if="gradeId !== 'all'"
                    @click="download('pdf')"
                    link
                  >
                    <v-list-item-title
                      ><v-icon color="red" small left>picture_as_pdf</v-icon>
                      &nbsp;PDF</v-list-item-title
                    >
                  </v-list-item>
                  <v-list-item link @click="download('excel')">
                    <v-list-item-title
                      ><v-icon color="success" small left>border_all</v-icon
                      >&nbsp;&nbsp; Download EXCEL</v-list-item-title
                    >
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-menu>
          </v-card-title>
          <v-card>
            <v-card-title outlined row wrap>
              <v-flex xs2>
                <v-grade-field
                  v-model="gradeId"
                  :inside="true"
                  @selectedGrade="gradesSection"
                  :with-all="true"
                ></v-grade-field>
              </v-flex>
              <v-flex xs2>
                <v-section-field
                  :sections="sections"
                  v-model="sectionId"
                ></v-section-field>
              </v-flex>
              <!-- <v-flex xs2>
                <v-student-search-field
                  :withDeleted="true"
                  @onClear="onClear"
                  @onSelectStudent="selectStudent"
                ></v-student-search-field>
              </v-flex> -->
              <!-- <v-flex xs1>
                <v-autocomplete
                  :disabled="!gradeId"
                  v-model="driverId"
                  :items="driveUser"
                  :search-input.sync="searchDriver"
                  hide-no-data
                  item-text="Name"
                  item-value="id"
                  label="Driver"
                  placeholder="Start typing to Search"
                  return-object outlined dense
                  :append-icon="(driverId && driverId !== 'all' )? 'close' : ''"
                  @click:append="clearDriver"
                >
                </v-autocomplete>
              </v-flex> -->

              <!-- <v-flex xs2>
                <v-autocomplete
                  :disabled="!gradeId"
                  v-model="guardianId"
                  :items="guardianUser"
                  :search-input.sync="searchGuardian"
                  hide-no-data
                  item-text="Name"
                  item-value="id"
                  label="Guardian"
                  placeholder="Start typing to Search"
                  return-object outlined dense
                  :append-icon="(guardianId && guardianId !== 'all' )? 'close' : ''"
                  @click:append="clearGuardian"
                >
                </v-autocomplete>
              </v-flex> -->
              <v-flex xs2>
                <v-select :items="routes" required  label="Select Route" outlined dense v-model="routeId" :disabled="!gradeId"> </v-select>
              </v-flex>
              <v-flex xs2>
                <v-select :items="vehicles" required label="Select Vehicle" outlined dense v-model="vehicleId" :disabled="!gradeId"> </v-select>
              </v-flex>
              <v-flex xs2>
                <v-select :items="fareDestinations" required label="Select Destination" outlined dense v-model="destinationId" :disabled="!gradeId"> </v-select>
              </v-flex>
              <v-flex xs1>
                <search-button
                  :disabled="!gradeId"
                  permission="subject-read"
                  @action="get()"
                  >Search</search-button
                >
              </v-flex>

              <v-flex xs1>
                <v-spacer></v-spacer>
                <v-btn
                  @click="moreFilterDialogue = true"
                  color="primary"
                  style="margin-top: -20px; float: right"
                  elevation="2"
                  icon
                  ><v-icon>filter_alt</v-icon></v-btn
                >
              </v-flex>
            
            </v-card-title>
          </v-card>
          <br />
          <div class="data-represent" v-if="transportForm.items.data.length > 0">
            <div>
              <span class="d-info"></span>&nbsp;
              <strong>{{ transportForm.items.meta.total }}</strong>
              <small> Total Record</small>
            </div>
            <div>
              <span class="d-success"></span>&nbsp;
              <strong>{{ totalTransportFee }}</strong>
              <small> Transport Fee</small>
            </div>
          </div>
          <br>

          <v-data-table
        
            :headers="headers"
            :hide-default-footer="transportForm.items.data.length < 1"
            :items="transportForm.items.data"
            :footer-props="footerProps"
            sort-by="roll"
            :options.sync="pagination"
            :server-items-length="transportForm.items.meta.total"
            :loading="transportForm.loading"
          >
            <template v-slot:item="{ index, item }">
              <tr>
                <td>{{ index + 1 }}</td>
                <td class="text-xs-left">{{ item.name }}
                  <br>
                  <span style="font-size: 10px; color: #666"
                      >(Enroll Code: {{ item.enroll_code }})
                  </span>
                </td>
                <td class="text-xs-center">
                  <strong>{{ item.roll }}</strong>
                </td>
                <td class="text-xs-left">
                  {{ item.guardian_name }}
                  <br>
                  <span style="font-size: 10px; color: #666" v-if="item.contact !== 'null'"
                      >(Contact: {{ item.contact }})
                  </span>
                </td>
                <td class="text-xs-left">{{ item.route || "-" }}</td>
                <td class="text-xs-left">{{ item.destination || "-" }}</td>
                <td>
                  <span v-if="item.vehicles.length > 0">
                    <!-- :class="vehicle !== '' ? ' success white--text mr-2' :''" -->
                    <v-chip
                    small
                    v-for="(vehicle, index) in item.vehicles"
                    :key="vehicle.id"
                    :class="index === 0 ?'success white--text mr-2' : 'warning white--text mr-2'"
                    style="margin-top: 5px;"
                    >
                    <span v-if="index ===0">
                      <!-- <span v-if="vehicle"> -->
                        Primary : {{ vehicle }} 
                      <!-- </span> -->
                    
                    </span>

                    <span v-else>
                      Secondary : {{ vehicle }}
                    </span>
                  </v-chip>
                  </span>
                  <span v-else>
                    -
                  </span>
                 
                </td>
                <td>
                  {{ item.driver || '-' }}
                  <br>
                  <span style="font-size: 10px; color: #666" v-if="item.driver && item.driver_number != 'null' "
                      >(Contacts: {{ item.driver_number}})
                  </span>
                </td>
                <td class="text-xs-left">
                  <strong> {{ item.rate ? "NRS " + item.rate : "-" }}</strong>
                  <br />
                  <small v-if="item.rate && item.discount"
                    >Discount {{ item.discount }}% i.e NRS
                    <strong>{{
                      Math.round(item.rate * (item.discount / 100))
                    }}</strong>
                  </small>
                </td>
               
              </tr>
            </template>
            <v-alert
              slot="no-results"
              :value="true"
              color="error"
              icon="warning"
            >
              Your search found no results.
            </v-alert>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="moreFilterDialogue" persistent max-width="550">
      <v-card>
        <v-card-title class="title pa-3 primary white--text">
          <v-icon class="mr-2 white--text">filter_alt</v-icon>
          More Filters
        </v-card-title>

        <v-card-title class="title pa-3">
          <br />
          <v-flex xs12>
            <v-student-search-field
              :withDeleted="true"
              @onClear="onClear"
              @onSelectStudent="selectStudent"
            ></v-student-search-field>

          </v-flex>
          <v-flex xs12>
            <v-autocomplete
                v-model="driverId"
                :items="driveUser"
                :search-input.sync="searchDriver"
                hide-no-data
                item-text="Name"
                item-value="id"
                label="Driver"
                placeholder="Start typing to Search"
                return-object outlined dense
                :append-icon="(driverId && driverId !== 'all' )? 'close' : ''"
                @click:append="clearDriver"
              >
            </v-autocomplete>
          </v-flex>
          <v-flex>
            <v-autocomplete
                v-model="guardianId"
                :items="guardianUser"
                :search-input.sync="searchGuardian"
                hide-no-data
                item-text="Name"
                item-value="id"
                label="Guardian"
                placeholder="Start typing to Search"
                return-object outlined dense
                :append-icon="(guardianId && guardianId !== 'all' )? 'close' : ''"
                @click:append="clearGuardian"
              >
              </v-autocomplete>
          </v-flex>
         
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="warning"
            outlined
            small
            @click="moreFilterDialogue = false"
            >Close</v-btn
          >
          <!-- <v-btn color="success" @click="get()" small>
            Filter Now
          </v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Form from "@/library/Form";
import Mixins from "@/library/Mixins";
import { redirectDownloadUrl } from "../../../../library/helpers";

export default {
  mixins: [Mixins],
  components: {
    // GradeSectionFilter,
  },
  data: () => ({
    // btns: [["Removed", "0"]],
    // colors: ["deep-purple accent-4", "error", "teal darken-1"],
    // items: [...Array(4)].map((_, i) => `Item ${i}`),
    downloadColumns: [
      { value: "roll", name: "Roll No.", selected: true },
      { value: "grade", name: "Grade", selected: false },
      { value: "section", name: "Section", selected: false },
      { value: "name", name: "Student Name", selected: true },
      {
        value: "guardian_name,contact",
        name: "Guardian Name / Contact",
        selected: false,
      },
      { value: "route", name: "Route", selected: true },
      { value: "destination", name: "Destination", selected: true },
      { value: "driver", name: "Driver Name", selected: false },
      // { value: "vehicle", name: "Vehicle Name", selected: false },
      // { value: "vehicle_no", name: "Vehicle No.", selected: false },
      { value: "vehicles", name: "Vehicles.", selected: false },
      { value: "rate", name: "Rate", selected: true },
      { value: "discount", name: "Discount", selected: true },
    ],
    // migrateDialog: false,
    transportForm: new Form(
      {
        route_id: "",
        enroll_id: "",
        discount: "",
        fare_id: "",
      },
      "/api/transport/report"
    ),
    // routes: [],
    // fare: "",
    // url: "",
    // destinations: [],
    // oldBatch: {},
    headers: [
      { text: "#", align: "left", value: "sno", sortable: false, width: 20 },
      {
        text: "Name",
        align: "left",
        value: "name",
        sortable: false,
        width: 180,
      },
      { text: "Roll No.", align: "left", value: "roll", sortable: false },
      { text: "Guardian", align: "left", value: "guardian", sortable: false },
      { text: "Route", align: "left", value: "type", sortable: false },
      { text: "Destination", align: "left", value: "seat", sortable: false },
      { text: "Vehicles", align: "left", value: "vehicles", sortable: false },
      { text: "Driver", align: "left", value: "driver", sortable: false },
      {
        text: "Fee",
        align: "left",
        value: "driver",
        sortable: false,
        width: 140,
      },
    ],
    gradeId: "",
    sectionId: "",
    enrollCode: "",
    routeId:"",
    vehicleId:"",
    driverId: "",
    guardianId: "",
    destinationId: "",
    sections: [],
    
    pagination: {
      itemsPerPage: 25,
    },
    // rowsPerPageItems: [5, 10, 25, 50, 75],
    // drivers: [],
    // search: "",
    // studentWithTransporations: [],
    download_url: "",
    routes: [],
    vehicles: [],
    driverEntries: [],
    guardianEntries: [],
    fareDestinations: [],
    searchDriver: '',
    searchGuardian: '',
    totalTransportFee: 0,
    moreFilterDialogue: false

  }),
  watch: {
    pagination: function() {
      this.get();
    },
    gradeId: function() {
      this.sectionId = "";
      this.transportForm.items.data = [];
      //   this.get();
    },
    // sectionId: function() {
    //   //   this.get();
    // },
    enrollCode: function() {
      this.transportForm.items.data = [];
      this.get();
    },
    searchDriver(val) {
        if (!val) return;
        if (this.isLoading) return;

        this.isLoading = true;
        this.$rest.get('api/user-search/slim?type=driver&search=' + val)
            .then(({data}) => {
                this.driverEntries = data.data
            }).catch(err => {
        }).finally(() => (this.isLoading = false))
    },
    searchGuardian(val) {
        if (!val) return;
        if (this.isLoading) return;

        this.isLoading = true;
        this.$rest.get('api/user-search/slim?type=guardian&search=' + val)
            .then(({data}) => {
                this.guardianEntries = data.data
            }).catch(err => {
        }).finally(() => (this.isLoading = false))
    },
    driverId: function() {
      this.get()
    },
    guardianId: function() {
      this.get()
    }
  },
   computed: {
    driveUser() {
        return this.driverEntries.map(entry => {
            return Object.assign({}, entry, {Name: entry.name})
        })
    },
    guardianUser() {
        return this.guardianEntries.map(entry => {
            return Object.assign({}, entry, {Name: entry.name})
        })
    }
  },
  mounted() {
    this.getRoute();
    this.getVehicles();
    this.getFareDestination();
  },
  methods: {
    clearDriver() {
      this.driverId = '';
      this.searchDriver = '';
      this.transportForm.items.data = []
      this.get()
    },
    clearGuardian() {
      this.guardianId = '';
      this.searchGuardian = '';
      this.transportForm.items.data = []
      this.get()
    },
    gradesSection(grade) {
      this.sections = grade.sections;
    },

    get() {
      if (!this.gradeId && !this.enrollCode && !this.driverId && !this.guardianId) {
        return;
      }
      let query = this.queryString(
        `gradeId=${this.gradeId}&sectionId=${this.sectionId}&enrollCode=${this.enrollCode}&routeId=${this.routeId}&vehicleId=${this.vehicleId}&driverId=${this.driverId ? this.driverId.id ?? '' : ''}&guardianId=${this.guardianId ? this.guardianId.id ?? '' : ''}&destinationId=${this.destinationId}`
      );
      this.transportForm
        .get(null, query)
        .then((res) => {
          console.log(res)
            this.totalTransportFee = res.data.data.reduce((sum, student) => {
              return sum + Number(student.rate || 0);
            }, 0);
          // this.download_url = res.data.download_url;
        })
        .catch((err) => {});
    },
     selectStudent(student) {
      if(student) {
        this.enrollCode = student.enroll_code
      }
    },
    onClear(){
      this.enrollCode = '';
      this.get();
    },
    getRoute(){
      this.routes = [{ value: 'all', text: 'All' }];
      this.$rest.get('/api/route?rowsPerPage=100').then((res) => {
        const additionalRoutes = res.data.data.map((item) => {
          return { text: item.name, value: item.id };
        });
        this.routes = [{ value: 'all', text: 'All' }, ...additionalRoutes];
      });
    },
    getVehicles(){
      this.$rest.get('/api/vehicle?rowsPerPage=100').then((res) => {
         const additionalVehicles = res.data.data.map((item) => {
          return { text: item.name, value: item.id };
        });
        this.vehicles = [{ value: 'all', text: 'All' }, ...additionalVehicles];
      })
    },

    getFareDestination(){
      this.$rest.get('/api/fare?rowsPerPage=100').then((res) => {
        const additionalDestination = res.data.data.map((item) => {
          return { text: item.destination, value: item.id };
        });
        this.fareDestinations = [{ value: 'all', text: 'All' }, ...additionalDestination];
      })
    },

    // getDrivers() {
    //   this.$rest.get("/api/member?type=driver").then(({ data }) => {
    //     this.drivers = data.data.map((driver) => {
    //       return { text: driver.name, value: driver.id };
    //     });
    //   });
    // },
    // getRoutes() {
    //   this.$rest.get("/api/route?rowsPerPage=25").then(({ data }) => {
    //     let $this = this;
    //     this.routes = data.data.map((route) => {
    //       return { text: route.name, value: route.id };
    //     });
    //   });
    // },
    // getDestinations() {
    //   this.$rest
    //     .get(
    //       "/api/route-fare?rowsPerPage=25&routeId=" +
    //         this.transportForm.route_id
    //     )
    //     .then((res) => {
    //       this.destinations = res.data.map(function(des) {
    //         return {
    //           text: des.destination,
    //           value: des.fare_id,
    //           rate: des.rate,
    //         };
    //       });
    //     });
    // },

    // olddownload(type) {
    //   let columns = [];
    //   this.downloadColumns.map((item) => {
    //     if (item.selected === true) columns.push(item.value);
    //   });

    //   if (columns.length > 0) {
    //     passDataToExternalDomain("reporting");
    //     setTimeout(() => {
    //       window.open(
    //         this.download_url + `&type=${type}&column=${columns.join(",")}`
    //       );
    //     }, 500);
    //   }
    // },
    download(type){
      let columns = [];
      this.downloadColumns.map((item) => {
        if (item.selected === true) columns.push(item.value);
      });
      
      if(columns.length > 0){
        redirectDownloadUrl({
            uri: "/download/transport",
            queryString:`type=${type}&gradeId=${this.gradeId}&sectionId=${this.sectionId}&enrollCode=${this.enrollCode}&routeId=${this.routeId}&vehicleId=${this.vehicleId}&column=${columns.join(",")}&driverId=${this.driverId ? this.driverId.id ?? '' : ''}&guardianId=${this.guardianId ? this.guardianId.id ?? '' : ''}&destinationId=${this.destinationId}`
          });
      }
    }
  },
};
</script>
<style>
.rate {
  position: absolute;
  margin-top: -20px;
  margin-left: 10px;
  color: gray;
  font-size: 12px;
}
.v-input--selection-controls .v-input__slot > .v-label,
.v-input--selection-controls .v-radio > .v-label {
  font-size: 14px !important;
}
.v-menu__content .v-input--selection-controls {
  margin-top: 0 !important;
}
</style>
